import styles from './ThreeDotsLoader.module.css';

export const ThreeDotsLoader = () => {
  return (
    <div className={styles.dotFlashing}></div>
  );
};
